// getWidevineInfo.js
// references https://websites.fraunhofer.de/video-dev/enabling-hardware-drm-on-android-chrome-using-the-encrypted-media-extensions/, https://w3c.github.io/encrypted-media/#dom-mediakeystatus
'use strict';

const cache = new Map();

const robustnessMap = {
  SW_SECURE_CRYPTO: {
    value: 'SW_SECURE_CRYPTO',
    widevineSecurityLevel: 'L3',
  },
  SW_SECURE_DECODE: {
    value: 'SW_SECURE_DECODE',
    widevineSecurityLevel: 'L3',
  },
  HW_SECURE_CRYPTO: {
    value: 'HW_SECURE_CRYPTO',
    widevineSecurityLevel: 'L2',
  },
  HW_SECURE_DECODE: {
    value: 'HW_SECURE_DECODE',
    widevineSecurityLevel: 'L1',
  },
  HW_SECURE_ALL: {
    value: 'HW_SECURE_ALL',
    widevineSecurityLevel: 'L1',
  },
};
/**
 * @typedef {Object} WidevineInfo
 * @property {string} securityLevel - widevine securiry level
 * @property {string} hdcpStatus - 2.2 hdcp status
 */

/**
 * Get Widevine information
 * @param {string} keySystem - drm keySystem.
 * @return {Promise<WidevineInfo>}
 */
const getWidevineInfo = async ({ keySystem }) => {
  if (cache.has(keySystem)) return cache.get(keySystem);

  const widevineInfo = await Object.keys(robustnessMap).reduce(
    async (result, key) => {
      const robustness = robustnessMap[key].value;
      const config = [
        {
          videoCapabilities: [
            {
              robustness,
              contentType: 'video/mp4;codecs=avc1.640028',
            },
          ],
        },
      ];
      try {
        const mediaKeySystemAccess =
          await navigator.requestMediaKeySystemAccess(keySystem, config);
        try {
          const mediaKeys = await mediaKeySystemAccess.createMediaKeys();
          const status = await mediaKeys.getStatusForPolicy({
            minHdcpVersion: '2.2',
          });
          return {
            securityLevel: robustnessMap[key].widevineSecurityLevel,
            hdcpStatus: status,
          };
        } catch (error) {
          return {
            securityLevel: robustnessMap[key].widevineSecurityLevel,
            hdcpStatus: 'no',
          };
        }
      } catch (error) {
        return result;
      }
    },
    { securityLevel: 'no', hdcpStatus: 'no' }
  );

  cache.set(keySystem, widevineInfo);

  return widevineInfo;
};

export default getWidevineInfo;
